import { StepsButtons } from "@/components/button/steps-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { LabelCheckbox } from "@/components/form/label-checkbox";
import { PageTitleComponent } from "@/components/page-title";
import { useDietaryRequirement } from "@/hooks/features/use-dietary-requirement";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { IonSkeletonText, useIonRouter } from "@ionic/react";

export default function ProfilingStepDietary() {
  const navigation = useIonRouter();
  const { info } = useStepRouteInfo();
  const {
    options,
    selectedOptions,
    setSelectedOptions,
    handleSubmit,
    isUpdating,
    isLoadingOptions,
  } = useDietaryRequirement(() => {
    navigation.push(info?.nextPath ?? "", "none");
  });

  if (isLoadingOptions) {
    return (
      <ProfilePageContainer>
        <PageTitleComponent
          title="Dietary Preferences / Requirements"
          description="Please select any dietary preferences or requirements you have from the list below."
          className="mt-2 mb-6 w-full"
        />
        <div className="grid grid-cols-2 gap-4 w-full">
          {Array.from({ length: 16 }).map((_, index) => (
            <IonSkeletonText className="w-full h-10" animated key={index} />
          ))}
        </div>
      </ProfilePageContainer>
    );
  }

  if (!options || options?.length === 0) {
    return (
      <ProfilePageContainer>
        <PageTitleComponent
          title="Dietary Preferences / Requirements"
          description="Please select any dietary preferences or requirements you have from the list below."
          className="mt-2 mb-6 w-full"
        />
        <div>No dietary requirements options found</div>
        <StepsButtons
          previousPath={info?.previousPath}
          nextPath={info?.nextPath}
          type="button"
          onClick={handleSubmit}
          disabled={isUpdating}
        />
      </ProfilePageContainer>
    );
  }

  return (
    <ProfilePageContainer>
      <PageTitleComponent
        title="Dietary Preferences / Requirements"
        description="Please select any dietary preferences or requirements you have from the list below."
        className="mt-2 mb-6 w-full"
      />

      <div className="w-full flex flex-col pb-20">
        <div className="grid grid-cols-2 gap-4">
          {options?.map((option) => {
            return (
              <LabelCheckbox
                key={option}
                label={option}
                value={option}
                checked={selectedOptions.has(option)}
                name="dietary"
                onChanged={(checked: boolean) => {
                  if (checked) {
                    setSelectedOptions((prev) => new Set(prev).add(option));
                  } else {
                    setSelectedOptions((prev) => {
                      const newSet = new Set(prev);
                      newSet.delete(option);
                      return newSet;
                    });
                  }
                }}
              />
            );
          })}
        </div>
        <StepsButtons
          previousPath={info?.previousPath}
          nextPath={info?.nextPath}
          type="button"
          onClick={handleSubmit}
          disabled={isUpdating}
        />
      </div>
    </ProfilePageContainer>
  );
}
